import {
  HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING,
  HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING,
  MARGIN_BOTTOM_TITLE_PANEL,
  MARGIN_TOP_NOTE,
  MARGIN_TOP_TITLE_PANEL,
  TYPE_ITEM_PDF,
} from '../constant'
import { getPdfHeightImage } from '../helper'

class PdfData {
  pdfData = []
  page = 1
  availableHeightPage = HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING
  currentPageData = { page: 1, items: [], isLandscape: false }
  currentTitlePanel = null

  addData = (item) => {
    if (item.type === TYPE_ITEM_PDF.CHAPTER_HEADER) {
      this.addChapterHeader(item)
    } else if (item.type === TYPE_ITEM_PDF.TITLE_PANEL) {
      this.currentTitlePanel = item
    } else if (item.type === TYPE_ITEM_PDF.CONTENT_PANEL) {
      this.addContentPanel(item)
    } else if (item.type === TYPE_ITEM_PDF.NOTE) {
      this.addNote(item)
    }
  }

  addNewPage = (isLandscape = false) => {
    this.pdfData.push(this.currentPageData)
    this.page += 1
    this.availableHeightPage = isLandscape
      ? HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING
      : HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING
    this.currentPageData = { page: this.page, items: [], isLandscape }
  }

  addChapterHeader = (item) => {
    const img = item.img[0]
    if (this.currentPageData.items.length) {
      this.addNewPage(item.isLandscape)
    }
    let heightChaperHeader = getPdfHeightImage(
      img.width,
      img.height,
      item.isLandscape,
    )
    this.currentPageData.items.push({
      img: img.data,
      type: TYPE_ITEM_PDF.CHAPTER_HEADER,
      title: item.title,
      subTitle: item.subTitle,
    })
    this.availableHeightPage -= heightChaperHeader
  }

  addNote = (item) => {
    const img = item.img[0]
    let heightNote = getPdfHeightImage(img.width, img.height, item.isLandscape)
    if (this.currentPageData.items.length) {
      heightNote += MARGIN_TOP_NOTE
    }
    if (this.availableHeightPage < heightNote) {
      this.addNewPage(item.isLandscape)
      heightNote -= MARGIN_TOP_NOTE
    }
    this.currentPageData.items.push({
      img: img.data,
      type: TYPE_ITEM_PDF.NOTE,
    })
    this.availableHeightPage -= heightNote
  }

  addContentPanel = (item) => {
    if (item.img) {
      const imgTitle = this.currentTitlePanel?.img?.[0]
      item.img.forEach(({ data, width, height }, index) => {
        let heightContent = getPdfHeightImage(width, height, item.isLandscape)
        if (!index && imgTitle) {
          heightContent += getPdfHeightImage(
            imgTitle.width,
            imgTitle.height,
            item.isLandscape,
          )
          if (this.currentPageData.items.length) {
            heightContent += MARGIN_TOP_TITLE_PANEL + MARGIN_BOTTOM_TITLE_PANEL
          }
        }
        if (this.availableHeightPage < heightContent) {
          this.addNewPage(item.isLandscape)
          if (imgTitle) {
            heightContent -= MARGIN_TOP_TITLE_PANEL
          }
        }
        if (!index && imgTitle) {
          this.currentPageData.items.push({
            img: imgTitle.data,
            type: TYPE_ITEM_PDF.TITLE_PANEL,
            title: this.currentTitlePanel.title,
            subTitle: this.currentTitlePanel.subTitle,
          })
          this.currentTitlePanel = null
        }
        this.currentPageData.items.push({
          img: data,
          title: index ? undefined : item.title,
          subTitle: index ? undefined : item.subTitle,
          type: TYPE_ITEM_PDF.CONTENT_PANEL,
        })
        this.availableHeightPage -= heightContent
      })
    }
  }

  getData = () => {
    this.pdfData.push(this.currentPageData)
    return this.pdfData
  }

  getAvailableHeightPage = () => {
    return this.availableHeightPage
  }

  getCurrentTitlePanel = () => {
    return this.currentTitlePanel
  }
}

export default PdfData
